import {
  formatTime,
  monitorSourceName,
  renderValidation,
  transRegion,
} from '../../render-helper';

function convertImageToCanvas(text) {
  var canvas = document.createElement('canvas');
  canvas.width = 25;
  canvas.height = 25;
  let ctx: any = canvas.getContext('2d');
  ctx.font = '20px serif';
  ctx.fillText(text, 0, 20);
  return canvas
    .toDataURL('image/png')
    .replace('image/png', 'image/octet-stream');
}

function dealwithExtJson(extJson) {
  if (extJson) {
    const showArray: Array<string> = [];
    let info: any = {};
    try {
      info = JSON.parse(extJson);
    } catch (error) {}
    let total = 0;
    for (const key in info?.reactions || {}) {
      const element = info.reactions[key];
      // let img = convertImageToCanvas(key);
      showArray.push(`${key} ${element}`);
      total += element;
    }
    return { text: showArray, total };
  }
  return { text: [], total: '' };
}

function renderInfo(type) {
  return (item, key) => {
    const { text, total } = dealwithExtJson(item?.[key]);
    if (type === 'Reactions') {
      return text.join(' , ');
    }
    return total;
  };
}

export default [
  { header: 'channel', render: 'channel_name' },
  {
    header: 'Content_Original',
    render: 'content',
  },
  {
    header: 'Content_Chinese',
    render: 'content_to_zh',
  },
  {
    header: 'Content_English',
    render: 'content_to_en',
  },
  {
    header: 'Validation',
    render: 'isvalid',
    width: 10,
    renderHelper: [renderValidation],
  },
  {
    header: 'Reactions',
    render: 'ext_json',
    renderHelper: [renderInfo('Reactions')],
  },
  { header: 'Votes', render: 'tweets_like' },
  {
    header: 'Monitor Source',
    renderHelper: [monitorSourceName],
  },
  {
    header: 'Date',
    render: 'comment_time',
    renderHelper: [formatTime('YYYY-MM-DD')],
  },
  {
    header: 'Time(UTC+8:00)',
    render: 'comment_time',
    renderHelper: [formatTime('YYYY-MM-DD HH:mm:ss')],
  },
  {
    header: 'Language',
    render: 'language',
    renderHelper: [transRegion(3)],
  },
  { header: 'Topic', render: 'topic' },
];
